export const SITE = {
  name: "National Biscuit & Sweet Manufacturers",
  short: "NBS National",
  tagline: "Baking since 1961",
  address: "Plot No. 161, Vithalwadi Station Road, Opp. Maruti Showroom, Ulhasnagar 421 003, Maharashtra, India",
  email: "nationalbiscuits@gmail.com",
  web: "www.nationalbiscuits.in",
  mapsEmbed: "https://www.google.com/maps?q=National%20Biscuit%20And%20Sweet%20Manufacturers%2C%20Vithalwadi%20Station%20Road%2C%20Ulhasnagar%20421003%2C%20Maharashtra&output=embed",
  mapsLink: "https://www.google.com/maps/search/?api=1&query=National+Biscuit+And+Sweet+Manufacturers,+Vithalwadi+Station+Road,+Ulhasnagar+421003",
  whatsapp: "https://wa.me/919702045551",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Biscuit Industry", to: "/biscuit-industry" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact Us", to: "/contact" },
];

export const PEOPLE = [
  { name: "Sagar Nagpal", role: "Exports & Sales", phone: "+91 97020 45551", tel: "+919702045551", wa: "https://wa.me/919702045551" },
  { name: "Sudeep Nagpal", role: "Production & Operations", phone: "+91 96570 02551", tel: "+919657002551", wa: "https://wa.me/919657002551" },
];

export const GROUP_FIRMS = [
  { name: "Stark Enterprises", url: "https://www.starkent.in", desc: "Corrugated boxes, cartons & packaging" },
  { name: "Manvi Travels", url: "https://www.manvitravels.in", desc: "International holiday packages" },
  { name: "Kanhaiya Food Products", url: "https://www.kanhaiyafoods.in", desc: "Confectionery — lollipop, candy, toffee" },
];

export const TIMELINE = [
  {
    year: "1961",
    title: "A hand oven and a promise",
    body: "Seth Papumal (Parsram) and Seth Narimal Nagpal begin baking biscuits in a single small room in Ulhasnagar — one hand oven, pure ingredients and a habit of never short-changing a customer.",
  },
  {
    year: "The early years",
    title: "Among the first to package",
    body: "While biscuits were still sold loose from tins, National became one of the area's first packaged-food units — every biscuit sealed, dated and trusted.",
  },
  {
    year: "1970s – 1990s",
    title: "The children expand the dream",
    body: "The second generation — Deepak, Kanu, Manohar and Girdhari — worked with the same grit their fathers were known for. Hard-working and dedicated, they expanded not only the factory and its infrastructure but also the reach: from markets all over India to Africa and the UAE. Under them the business soared to newer heights.",
  },
  {
    year: "1998",
    title: "The export pivot",
    body: "National took its bakes beyond Indian shores. Direct exports and merchant exports carried the red NBS crest to new continents.",
  },
  {
    year: "Today",
    title: "The third generation",
    body: "The Nagpal family's third generation runs a modern, export-first plant — state-of-the-art machinery, the same 1961 promise — with a sharp focus on Africa and the Gulf.",
  },
];

export const CHAPTERS = [
  {
      title: "Roots",
    body: "One room. One hand oven. Two brothers-in-enterprise, Seth Papumal (Parsram) and Seth Narimal Nagpal, baking biscuits in 1961 Ulhasnagar. Everything the company is today was decided in that small room: make it good, make it honest, make it again tomorrow.",
  },
  {
      title: "Goodwill",
    body: "Value-driven business is not a slogan here — it is the inheritance. Among the first packaged-food units in the region and one of its most renowned names ever since, National grew because grocers re-ordered and families returned.",
  },
  {
      title: "The modern plant",
    body: "High-speed mixers, auto dough feeders, a rotary moulder, a running tunnel oven, online packaging machines and online cream-sandwiching-cum-packing machines — a bright, clean, modern floor where uniformed workers in caps and gloves craft every batch.",
  },
  {
      title: "Going global",
    body: "In 1998 the compass turned outward. Today the export desk concentrates on African countries and the Gulf — through its own direct exports and merchant exports — with factory stuffing into 40ft high-cube containers for all major global ports.",
  },
];

export const BISCUITS = [
  {
    id: "glucose",
    name: "Glucose Biscuits",
    kind: "Biscuits",
    img: "images/p_glucose_mockup.jpeg",
    accent: "#D99C41",
    blurb: "The everyday classic — light, crisp and energy-rich. The biscuit that built the brand, still baked to the original brief.",
    flavours: ["Original"],
    grammages: ["8 g", "25-27 g", "30 g", "35 g", "40 g", "45 g", "50 g", "52-55 g", "60 g", "65 g"],
    packing: "Available from 8 g to 65 g across pillow & pile-pack formats — carton stuffing for export.",
  },
  {
    id: "milk-malt",
    name: "Milk Plus Biscuits",
    kind: "Biscuits",
    img: "images/p_milk_mockup.jpeg",
    accent: "#C98A2E",
    blurb: "Slow-toasted milk warmth baked into every rectangular bite. Comfort you can dip.",
    flavours: ["Milk", "Milk Malt"],
    grammages: ["8 g", "25-27 g", "30 g", "35 g", "40 g", "45 g", "50 g", "52-55 g", "60 g", "65 g"],
    packing: "Available from 8 g to 65 g across pillow & pile-pack formats — carton stuffing for export.",
  },
  {
    id: "nice-coconut",
    name: "Nice Coconut Biscuits",
    kind: "Biscuits",
    img: "images/p_nice_pack.jpeg",
    accent: "#E0A458",
    blurb: "Golden ovals with a crisp forked pattern, generously sprinkled with sugar crystals and laced with coconut.",
    flavours: ["Coconut"],
    grammages: ["50 g", "100 g", "200 g"],
    packing: "Pile-pack, multipacks & bulk cartons.",
  },
  {
    id: "cream-rect",
    name: "Rectangular Cream Biscuits (Twisti)",
    kind: "Biscuits",
    img: "images/p_rect_cream.jpeg",
    accent: "#7A1416",
    blurb: "Patterned rectangular biscuits sandwiching rich creams — baked on our online cream-sandwiching-cum-packing machines.",
    flavours: ["Strawberry", "Pineapple", "Vanilla", "Chocolate"],
    grammages: ["11-13 g", "22-26 g", "33-39 g", "50 g", "70 g", "80 g"],
    packing: "11-13 g, 22-26 g & 33-39 g available under pile pack; 50 g, 70 g & 80 g additionally in pillow packs & cartons.",
  },
  {
    id: "cream-round",
    name: "Round Cream Biscuits (Twisti)",
    kind: "Biscuits",
    img: "images/pack_cream_chocolate.png",
    accent: "#E91E8C",
    blurb: "The signature Twisti round — the original cream sandwich in five flavours, matched biscuit-for-biscuit to the brand shape.",
    flavours: ["Chocolate", "Strawberry", "Mango", "Orange", "Vanilla"],
    grammages: ["11-13 g", "22-26 g", "33-39 g", "50 g", "70 g", "80 g"],
    packing: "11-13 g, 22-26 g & 33-39 g available under pile pack; 50 g, 70 g & 80 g additionally in pillow packs & cartons.",
  },
  {
    id: "fruit",
    name: "Fruit Flavoured Biscuits",
    kind: "Biscuits",
    img: "images/p_fruit_pack.jpeg",
    accent: "#F07818",
    blurb: "A regular crisp biscuit with premium fruit flavouring baked in — no cream, just bright fruit notes in every bite.",
    flavours: ["Pineapple", "Orange", "Strawberry", "Banana", "Mango", "Lemon"],
    grammages: ["40 g", "60 g"],
    packing: "Pile-pack, multipacks & bulk cartons.",
  },
];

export const TWISTI_PACKS = [];

export const CONFECTIONERY = {
  unit: "Kanhaiya Food Products",
  img: "images/p_confectionery.jpeg",
  blurb:
    "Under our sister manufacturing unit, Kanhaiya Food Products, we make all types of confectionery — round ball lollipops, sugar-boiled candy, toffee, éclair and bubblegum.",
  items: ["Lollipops", "Candy", "Toffee", "Éclair", "Bubblegum", "Gum-filled Lollipops"],
};

export const PILE_PACKS = [
  { label: "Pile pack — Glucose", img: "images/p_pile_glucose.jpeg" },
  { label: "Pile pack — Cream", img: "images/p_pile_cream.jpeg" },
];

export const MACHINERY = [
  { no: "01", name: "High-speed mixers", img: "images/mixer_dough.jpeg", body: "Cream-coloured dough, mixed to the same recipe every single shift." },
  { no: "02", name: "Auto dough feeders", img: "images/dough_feeder.jpeg", body: "Dough sheeted to a uniform thickness — no hands, no guesswork." },
  { no: "03", name: "Rotary moulder", img: "images/hero_line.jpeg", body: "Every biscuit cut with the same clean impression, thousands per minute." },
  { no: "04", name: "Running tunnel oven", img: "images/tunnel_oven.jpeg", body: "A slow, even bake along the full length of the band oven." },
  { no: "05", name: "Online packaging machines", img: "images/workers_packaging.jpeg", body: "Sealed, coded and cartoned the moment they cool — freshness locked on the line." },
  { no: "06", name: "Cream sandwiching cum packing", img: "images/cream_machine.jpeg", body: "Cream deposited, biscuits married and packed in one continuous motion." },
];

export const RAW_MATERIALS = [
  { name: "Wheat flour", body: "Carefully selected milling wheat, sifted fresh for every batch.", img: "images/wheat_field.jpeg" },
  { name: "Sugar", body: "Fine, clean crystals — sweetness that carries, never masks.", img: "images/raw_materials.jpeg" },
  { name: "Flavours & colours", body: "Premium food-grade flavours and colours only.", img: "images/p_fruit.jpeg" },
  { name: "Packaging", body: "Premium food-grade packaging materials, sealed on the line.", img: "images/workers_packaging.jpeg" },
];

export const EXPORT_FACTS = [
  { k: "1961", v: "Baking since" },
  { k: "1998", v: "Exporting since" },
  { k: "3", v: "Generations" },
  { k: "2", v: "Continents served" },
  { k: "Africa · Gulf", v: "Focus export markets" },
  { k: "40ft HC", v: "Container factory stuffing" },
];

export const PORT_REGIONS = [
  { region: "North Africa", ports: ["Casablanca", "Algiers", "Tunis", "Alexandria"] },
  { region: "West Africa", ports: ["Dakar", "Abidjan", "Tema", "Lagos (Apapa)", "Douala"] },
  { region: "Central Africa", ports: ["Libreville", "Pointe-Noire", "Luanda"] },
  { region: "East & Southern Africa", ports: ["Mombasa", "Dar es Salaam", "Maputo", "Durban", "Gqeberha", "Cape Town", "Walvis Bay"] },
  { region: "Horn of Africa", ports: ["Djibouti"] },
  { region: "UAE", ports: ["Dubai (Port Rashid)", "Jebel Ali"] },
];

export const TESTIMONIALS = [
  {
    quote:
      "Decades of consistent quality. Our shelves in Lagos never see the cartons sit for long — the Twisti packs move the moment they arrive.",
    name: "Distribution Partner",
    place: "Lagos, Nigeria",
  },
  {
    quote:
      "Clean documentation, honest timelines, containers that arrive exactly as promised. A supplier you can build a market on.",
    name: "Importer & Trading House",
    place: "Dubai, UAE",
  },
  {
    quote:
      "Their cream biscuits opened an entirely new category for us. The price-to-quality is the best we have sourced from India.",
    name: "Wholesale Buyer",
    place: "Mombasa, Kenya",
  },
  {
    quote:
      "Value for money without cutting a single corner on quality. Third-generation family business, and it shows in how they work.",
    name: "Merchant Export Associate",
    place: "Mumbai, India",
  },
];

export const RATING = {
  value: "4.3",
  outOf: "5",
  source: "Google",
  note: "Rated by our customers on Google",
};
